import React from "react";
import PropTypes from "prop-types";
import { Row, Col, FormControl, ControlLabel } from "react-bootstrap";
import { withTranslation } from "react-i18next";

import "./style.css";

class Search extends React.Component {
  static propTypes = {
    displayHeader: PropTypes.bool.isRequired,
    searchText: PropTypes.string.isRequired,
    onSearchTextInputChange: PropTypes.func.isRequired,
    onSearchSubmit: PropTypes.func.isRequired
  };

  static defaultProps = {
    searchText: ""
  };

  onSearchTextInputChange = e => {
    this.props.onSearchTextInputChange(e.target.value);
  };

  onSearchSubmit = e => {
    this.props.onSearchSubmit();
  };

  render() {
    const { displayHeader, searchText, t } = this.props;
    if (displayHeader) {
      return (
        <div className="card">
          <Row>
            <Col sm={12} md={9}>
              <div className="search-side">
                <ControlLabel>{t("Products.Search.Label")}</ControlLabel>
                <FormControl
                  type="text"
                  placeholder={t("Products.Search.Placeholder")}
                  value={searchText}
                  onChange={this.onSearchTextInputChange}
                />
              </div>
            </Col>
            <Col xs={12} sm={5} md={3} lg={3}  className="card__button">
              <button
                className="btn btn-primary btn-block btn-search"
                type="button"
                onClick={this.onSearchSubmit}
              >
                {t("Products.Search.Button")}                
              </button>
            </Col>
          </Row>
        </div>
      );
    } else {
      return <div />;
    }
  }
}

export default withTranslation()(Search);



// WEBPACK FOOTER //
// ./src/components/Products/Search/index.js